var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.129,
    height: 14.128,
    viewBox: "0 0 14.129 14.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11044",
    "data-name": "Group 11044",
    transform: "translate(-4527.816 -22388.441) rotate(-45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1533",
    "data-name": "Line 1533",
    y2: 13.128,
    transform: "translate(-12634.012 19038.016) rotate(-45)",
    fill: "none",
    stroke: "#3070c7",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1534",
    "data-name": "Line 1534",
    y2: 13.128,
    transform: "translate(-12624.729 19038.016) rotate(45)",
    fill: "none",
    stroke: "#3070c7",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlue);
export default __webpack_public_path__ + "static/media/Plus Blue.102224a7488bee0624504a9ae078090a.svg";
export { ForwardRef as ReactComponent };